import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import {
    createLinearStepper,
    ILinearStepperProperties,
    IStaticStepItem,
} from '@vfde-brix/ws10/linear-stepper';
import { AppId } from '../enums/elementId';
import { mountComponent } from '../util/mount';

/**
 *
 * @param stepperLabels - Array of Stepper labels.
 * @param activeSteps - Number of the active step.
 * Mounts Linear Stepper
 */
export const mountLinearStepper = (stepperLabels: string[], activeSteps: number) => {
    const stepperSteps: IStaticStepItem[] = stepperLabels.map(
        (stdTextLabel, i) => ({
            stdId: `${AppId.LINEAR_STEPPER}-${i}`,
            stdTextLabel,
        }),
    );

    const props: ILinearStepperProperties = {
        stepperSteps,
        optDynamicStepperSteps: false,
        business: NO_PATTERN_BUSINESS_LOGIC,
        optActiveStep: activeSteps,
    };

    return mountComponent(AppId.LINEAR_STEPPER, createLinearStepper, props);
};
